import { render, staticRenderFns } from "./OrderReceiverInfo.vue?vue&type=template&id=95fc97d8&scoped=true&"
import script from "./OrderReceiverInfo.vue?vue&type=script&lang=js&"
export * from "./OrderReceiverInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderReceiverInfo.vue?vue&type=style&index=0&id=95fc97d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fc97d8",
  null
  
)

export default component.exports